import { Order } from "@redotech/redo-model/order";
import { Return } from "@redotech/redo-model/return";
import { CopyableText } from "@redotech/redo-web/copyable-text";
import { CurrencyContext } from "@redotech/redo-web/currency";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useContext } from "react";

export const CustomerTotals = memo(function CustomerTotals({
  orders,
  returns,
}: {
  orders: Order[] | undefined;
  returns: Return[] | undefined;
}) {
  const { formatCurrency } = useContext(CurrencyContext);
  const totalOrders = orders?.length || 0;
  const totalReturns = returns?.length || 0;
  const totalOrderAmount = orders?.length
    ? orders.reduce(
        (accumulator: number, order: Order) =>
          accumulator +
          (order.shopify.financial_status === "paid"
            ? Number(
                order.shopify.current_total_price ??
                  order.shopify.total_price_usd ??
                  order.shopify.total_price,
              )
            : 0),
        0,
      )
    : 0;
  return (
    <Flex dir="column">
      <Flex justify="space-between">
        <Text fontSize="xs" fontWeight="medium" textColor="tertiary">
          Total spent
        </Text>
        <CopyableText fontSize="xs" fontWeight="medium" textColor="primary">
          {`${formatCurrency(totalOrderAmount)}`}
        </CopyableText>
      </Flex>
      <Flex justify="space-between">
        <Text fontSize="xs" fontWeight="medium" textColor="tertiary">
          Total orders
        </Text>
        <CopyableText fontSize="xs" fontWeight="medium" textColor="primary">
          {`${totalOrders}`}
        </CopyableText>
      </Flex>
      <Flex justify="space-between">
        <Text fontSize="xs" fontWeight="medium" textColor="tertiary">
          Total returns
        </Text>
        <CopyableText fontSize="xs" fontWeight="medium" textColor="primary">
          {`${totalReturns}`}
        </CopyableText>
      </Flex>
    </Flex>
  );
});
